import { useMemo } from 'react';

import { useI18n } from '@app-velocity/i18n';
import {
  Modal,
  useModalContext,
  useModalWrapperContext,
  Button,
} from '@app-velocity/ui';
import { ShareHumanTestingPasscode } from '@app-velocity/modules/password-sharing';
import { usePrototypePermissions } from '@app-velocity/modules/simulation-report';

import { ShareScenarioLink } from '../ShareScenarioLink';

type ShareScenarioModalContent = {
  shareToken: string;
  passcode: string;
  prototypeId: string;
};

const isSharedTokenData = (
  data: unknown
): data is ShareScenarioModalContent => {
  return !!(data as ShareScenarioModalContent).shareToken;
};

export const ShareScenarioModalContent = () => {
  const { closeModal } = useModalContext();
  const { modalData, openedModalId } = useModalWrapperContext();
  const { t } = useI18n();

  const { shareToken, prototypeId } = useMemo(() => {
    const currentModalData = modalData[openedModalId];

    if (isSharedTokenData(currentModalData)) {
      return {
        shareToken: currentModalData.shareToken,
        prototypeId: currentModalData.prototypeId,
      };
    }

    return {
      shareToken: '',
      prototypeId: '',
    };
  }, [modalData, openedModalId]);

  const { canManageAccess } = usePrototypePermissions(shareToken);

  return (
    <Modal data-testid="scenario-created-modal">
      <Modal.Header title="prototypes:share_scenario" />
      <Modal.Content>
        <ShareScenarioLink shareToken={shareToken} />
        {canManageAccess && prototypeId ? (
          <ShareHumanTestingPasscode prototypeId={prototypeId} />
        ) : null}
      </Modal.Content>
      <Modal.Controls>
        <Button
          onClick={() => closeModal()}
          color="secondary"
          variant="contained"
        >
          {t('shared:close')}
        </Button>
      </Modal.Controls>
    </Modal>
  );
};
